export default __webpack_public_path__ + "static/media/undraw_split.d75dfd01.svg";